import styled from 'styled-components';

export const Wrapper = styled.div`
  opacity: ${({ isDisabled }) => (isDisabled ? '0.5' : '1')};
  color: #2b313d;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;

export const Checked = styled.div`
  min-width: 12px;
  max-width: 12px;
  min-height: 12px;
  max-height: 12px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    min-width: 8px;
    max-width: 8px;
    min-height: 8px;
    max-height: 8px;
    border-radius: 50%;
    background-color: #000;
    display: block;
  }
`;

export const Unchecked = styled.div`
  max-width: 12px;
  max-width: 12px;
  min-width: 12px;
  min-height: 12px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #c4c4c4;
`;
